import convertArrayToObjectSchema from './convertArrayToObjectSchema';
import isValidEllingtonSchema from './isValidEllingtonSchema';

const validatedPayload = ({ data, display_schema }) => {
  let validatedData = data;
  let validatedDisplaySchema = display_schema;
  try {
    if (!isValidEllingtonSchema(display_schema)) {
      const [newSchema, newData] = convertArrayToObjectSchema(
        display_schema,
        data,
      );
      validatedDisplaySchema = newSchema;
      validatedData = newData;
    }
  } catch {
    // unable to correct, so leave the original schema
    validatedDisplaySchema = display_schema;
    validatedData = data;
  }
  return { data: validatedData, display_schema: validatedDisplaySchema };
};

export default validatedPayload;
